export default __webpack_public_path__ + "static/carrying-a51378d036179f4048fa275208800521.svg";